import { z } from "zod";
import { MediaSchema } from "./media";
import { PriceTypeSchema, type PriceType } from "./packaged-service";

/**
 * Schema for packaged service detail page
 * Transforms backend snake_case to frontend camelCase
 */
export const PackagedServiceDetailsSchema = z.object({
    id: z.number(),
    service_name: z.string(),
    slug: z.string(),
    description: z.string().nullable().optional(),
    starting_price: z.number().nullable().optional(),
    price_type: PriceTypeSchema.nullable().optional().default('fixed'),
    /** @deprecated Use featured_media instead */
    thumbnail: z.string().nullable().optional(),
    gallery_images: z.array(z.string()).nullable().optional().default([]),
    featured_media: MediaSchema.nullable().optional(),
    gallery_media: z.array(MediaSchema).nullable().optional().default([]),
});

export type PackagedServiceDetails = z.infer<typeof PackagedServiceDetailsSchema>;

